import React from "react";

const LikeOutlineIcon = ({ className = "w-5 h-5" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M7.5 9.75l3.75-7.5a3 3 0 013 3V7.5h5.8a1.5 1.5 0 011.489 1.686l-1.125 9a1.5 1.5 0 01-1.489 1.314H7.5M3 9.75h4.5v9.75H3a.75.75 0 01-.75-.75V10.5A.75.75 0 013 9.75v0z"
      ></path>
    </svg>
  );
};

export default LikeOutlineIcon;
